import template from './contract.create.html';
import controller from './contract.create.controller';
import './contract.create.controller';

let contractcreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default contractcreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract/create/contract.create.component.js